import React, { useState, useEffect, useContext } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import PremPlayersContext from "../../contexts/premplayers-context";
import { useSiteVarsFunctions } from "../../hooks/use-site-vars-functions";
import { getAllBidsCurrentPhaseResource, updateBidStatusResource } from "../../services/transfers.service";

export const ManageTransfers = (props) => {
  const {getPlayerPositionById, getTeamById, getClubName, getSiteVar } = useSiteVarsFunctions();
  const {premPlayersData, isLoadingPremPlayersData} =  useContext(PremPlayersContext);
  const [allBidsData, setAllBidsData] = useState([]);
  const [isLoadingAllBidsData, setIsLoadingAllBidsData] = useState(true);

  const fetchAllBids = async () => {
    setIsLoadingAllBidsData(true);
    const { data, error } = await getAllBidsCurrentPhaseResource();
    if (data) {
      setAllBidsData(data);
    }
    setIsLoadingAllBidsData(false);
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchAllBids();
    }
    
    return () => {
      isMounted = false;
    };
  }, []);

  // Sort bids by date (most recent first)
  allBidsData.sort((a, b) => {
    const nameA = a.playerName.toLowerCase();
    const nameB = b.playerName.toLowerCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // If player names are the same, sort by amount descending
    return b.amount - a.amount;
  });

  // Map player IDs to full player data
  const getPlayerData = (playerId) => {
    return premPlayersData.find(player => player.playerId === playerId);
  };

  return (
    <TableContainer component={Paper} sx={{ marginBottom:5 }}>
      {(isLoadingPremPlayersData || isLoadingAllBidsData) && (
        <Stack spacing={1}>
          <Skeleton variant="rounded" width={"100%"} height={30} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
        </Stack>
      )}
      {(!isLoadingPremPlayersData && !isLoadingAllBidsData) && (
        <Table sx={{ minWidth: 390 }} size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ paddingLeft: 6, paddingRight:0,paddingBottom: 0 }}></TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Player</TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Club</TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Bid</TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Status</TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allBidsData.map((bid) => {
              const player = getPlayerData(bid.playerId);
              if (!player) return null; // Skip if player data is not found

              const handleUpdateBid = async (status) => {
                await updateBidStatusResource(bid.bidId, bid["windowId+phaseId"], status);
                fetchAllBids(); // Refresh the data
              };

              return (
                <TableRow key={bid.bidId}>
                  <TableCell style={{ paddingLeft: 6, paddingRight:0, paddingBottom: 0 }}>
                    <img src={`https://resources.premierleague.com/premierleague25/photos/players/110x140/${player.photo.substr(0, player.photo.indexOf('.'))}.png`} style={{ width: '40px', height: '51px' }} />
                  </TableCell>
                  <TableCell style={{ paddingLeft: 6, paddingRight:6}}>
                    <span>{player.lastName}</span>
                    <br />
                    <span style={{fontWeight: 'bold'}}>{getPlayerPositionById(player.positionId).name_short}</span> {getTeamById(player.teamId).name_short}
                  </TableCell>
                  <TableCell style={{ paddingLeft: 6, paddingRight:6}}>{getClubName(bid.clubId)}</TableCell>
                  <TableCell style={{ paddingLeft: 6, paddingRight:6}}>{bid.amount}</TableCell>
                  <TableCell style={{ paddingLeft: 6, paddingRight:6}}>{bid.status}</TableCell>
                  <TableCell style={{ paddingLeft: 6, paddingRight:6}}>
                    {bid.status === "pending" && (
                      <>
                        <Button onClick={() => handleUpdateBid("win")} variant="outlined" color="success" size="small" style={{ fontSize: "x-small", padding:0, marginRight: "5px"}}>Win</Button>
                        <Button onClick={() => handleUpdateBid("lose")} variant="outlined" color="error" size="small" style={{ fontSize: "x-small", padding:0}}>Lose</Button>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};